export default __webpack_public_path__ + "static/media/javascript.2d1fc846.png";